import React from 'react'
import Image from 'next/image'

import headerLogoImg from '@/assets/header-logo.svg'

import styles from './SignUp.module.scss'

export default function FormBoxLogo() {
  return (
    <Image alt="Neat" className={styles.formBoxLogo} src={headerLogoImg} />
  )
}
